import { lazy, Suspense, ComponentProps } from 'react'
import Loader from 'components/SimpleLoader'

const Plan = lazy(() => import(
  /* webpackPrefetch: true */
  /* webpackChunkName: 'plan' */
  './Plan'
))

export function AsyncPlan(props: ComponentProps<any>) {
  return (
    <Suspense fallback={<Loader title="Loading Plan..." />}>
      <Plan {...props} />
    </Suspense>
  )
}

export default AsyncPlan
